import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {MaterialModule} from './_module/_core/material/material.module'


import {PageLayoutComponent} from './_shared/component/page-layout/page-layout.component'
import {NavbarComponent} from './_shared/component/navbar/navbar.component'
//import {FooterComponent} from './_shared/component/footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './_module/_core/transloco/transloco-root.module';
import { Router, Scroll } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { filter } from "rxjs/operators";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ScullyLibModule } from '@scullyio/ng-lib';
@NgModule({
  declarations: [
    AppComponent,
    //FooterComponent,
    NavbarComponent,PageLayoutComponent,
  ],
  imports: [
    SweetAlert2Module.forRoot(),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
 
    /**Material & Flex */
    MaterialModule,
    FormsModule, ReactiveFormsModule,
    HttpClientModule,
 
    TranslocoRootModule,
 
    ScullyLibModule
  
  ],
  exports:[
   // FooterComponent

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
/** Dodanie obslugiwania kotficy --> anchron 
 *  https://medium.com/@qun.do19/how-to-enable-anchor-scrolling-of-angular-router-in-the-right-way-42e9b19657b5
*/

  constructor(router: Router, viewportScroller: ViewportScroller) {
    viewportScroller.setOffset([0, 60]);
     router.events.pipe(filter(e => e instanceof Scroll)).subscribe((e: Scroll) => {
      if (e.anchor) {
        // anchor navigation
        setTimeout(() => {
          viewportScroller.scrollToAnchor(e.anchor);
        })
      } else if (e.position) {
        // backward navigation
        viewportScroller.scrollToPosition(e.position);
      } else {
        // forward navigation
        viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }
  
 }
